<template><div><h1 id="qualifikator" tabindex="-1"><a class="header-anchor" href="#qualifikator"><span>Qualifikator</span></a></h1>
<p>Qualifikator für Quellenzusatz — Definiert einen Qualifikator für einen Quellenzusatz</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Qualifikatoren können als Quellenzusätze definiert werden. Dieser dient als Zusatzinformation für die Quelle. Damit können beispielsweise verschiedene Adressgruppen gekennzeichnet werden.</p>
<p>Pfad: <code v-pre>Personen → Tabellen → Quellen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Qualifikator</dt>
<dd>Definition eines Qualifikators</dd>
<dt>Beschreibung</dt>
<dd>Beschreibung des Qualifikators</dd>
</dl>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.tblqzusatz.html" title="Quellenzusatz">Quellenzusatz</RouteLink></p>
</div></template>


